import { DataType, UnionDataType } from '../DataType';

export function createNullable(type: DataType): UnionDataType {
    return {
        kind: 'union',
        subTypes: [type, { kind: 'null' }],
    };
}
